import * as e from "react";
import "react/jsx-runtime";
const r = {
  disableDefaultClasses: !1
}, o = /* @__PURE__ */ e.createContext(r);
function l(t) {
  const {
    disableDefaultClasses: s
  } = e.useContext(o);
  return (a) => s ? "" : t(a);
}
export {
  l as useClassNamesOverride
};
//# sourceMappingURL=ClassNameConfigurator.mjs.map
